import React from 'react';
import { useNavigate } from 'react-router-dom';
import {IconWrapper} from "../appearence/icons/icon_wrapper";
import {PenIcon} from "../appearence/icons/pen_icon";

const EditItemIcon = ({ pageUrl }) => {
    const navigate = useNavigate();

    const navigateOnEditPage = () => {
        if (pageUrl) {
            navigate(pageUrl);
        }
    };

    return (
        <span onClick={navigateOnEditPage}>
            <IconWrapper><PenIcon/></IconWrapper>
        </span>
        
    );
};

export default EditItemIcon;
